module.exports = __webpack_public_path__ + "static/img/14003004.3befa8d2.png";